import React, { useContext } from 'react';
import {
	CreateGameCategoryContext,
	ICreateGameCategoryContext,
} from '../../../createGameCategoryState/createGameCategoryContext';
import { TranslationForm } from 'components/TranslationForm/TranslationForm';

interface IProps {
	isVisible: boolean;
}

const TranslationsForm: React.FC<IProps> = ({ isVisible }) => {
	const {
		setTranslationTab,
		changeNameTranslation,
		translations,
		selectedTranslationTab,
		fetchedLanguages,
		IDsSelectedLanguages,
	} = useContext<ICreateGameCategoryContext>(CreateGameCategoryContext);
	return (
		<TranslationForm
			setTranslationTab={setTranslationTab}
			changeNameTranslation={changeNameTranslation}
			isVisible={isVisible}
			IDsSelectedLanguages={IDsSelectedLanguages}
			translations={translations}
			selectedTranslationTab={selectedTranslationTab}
			fetchedLanguages={fetchedLanguages}
		/>
	);
};

export default TranslationsForm;
